const fileDownload = function (response, fileName) {
  const BLOB = new Blob([response])

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(BLOB, fileName)
  } else {
    const url = window.URL.createObjectURL(BLOB)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  }
}

export default fileDownload



// WEBPACK FOOTER //
// ./src/functions/fileDownload.js